import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import './LandingPage.css';
import Anime from './Anime.js';
import AnimeReflect from './AnimeReflect.js';
import Sky from './Sky.js';
import Button from './Button.js';
import Footer from './Footer';
import Box from './Box';
import Loading from './Loading';

function LandingPage({ api, free }) {
  useEffect(() => { api.setQueryTokenId('0'); }, []);

  // switch backgournd img 
  const imgClassList = ['field', 'snow', 'desert']
  const [imgClassId, setImgClassId] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setImgClassId(pre => (pre + 1) % imgClassList.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  // switch chicken img 
  const [imgId, setImgId] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setImgId(prevId => prevId >= (api.latestTokenId + 1) ? 0 : prevId + 1);
    }, 1600);
    return () => clearInterval(interval);
  }, []);

  const connectWalletAndMint = (api.currentAccount ?
    <Button onClick={api.mintNftHandler}> MINT CHICKEN 0.01 ETH </Button>
    :
    <a href='#Works'>
    <Button className='pixel-button connect-wallet-button'>
      <p style={{ fontFamily: "'Fredericka the Great', cursive" }} >My Works</p>
    </Button></a>);

  const connectWalletAndFreeMint = (api.currentAccount ?
    <Button onClick={api.freeMintNftHandler}> FREE MINT CHICKEN </Button>
    :
    <Button onClick={api.connectWalletHandler} className='pixel-button connect-wallet-button'>
      CONNECT WALLET TO FREE MINT
    </Button>);

  return (
    <div className='landingPage'>

      <Anime imgClass={imgClassList[imgClassId]}>

      </Anime>
      <AnimeReflect imgClass={imgClassList[imgClassId]} />
      

      <div className='landingPanelTop'>
        <p style={{ fontFamily: "'Fredericka the Great', cursive" }} id="title">Daniel‘s Studio</p>

        <br />
        {free ? connectWalletAndFreeMint : connectWalletAndMint}<br /><br />

        <p style={{ fontFamily: "'Fredericka the Great', cursive" }} >
          <br />Design, Build, and bring dreams to life.<br />

          <br /><br /><br />
        </p>
      </div>

      {/*<div className='landingPanelMid'>
        <h2>WHY BREED YOUR CHICKEN?</h2>
        <p> <br /><br />
          By showing your chicken page for others to mint (breed) from your chicken, you earn ETH.
          <br /><br />
          Meanwhile holding the chicken earns gold egg token every day.
          <br /><br />Most importantly, it's cool!
          <br /><br /><br />
        </p>

  </div>
*/}
      {/*<div style={{transform: 'translateY(100px)'}}>
      <Sky >
      " "
      </Sky>
      </div>*/}
      <Sky>
        <div className='midText' >
          <h2 id='Works' style={{ fontFamily: "'Fredericka the Great', cursive", fontWeight: 'normal' }} >Works</h2><br /><br />
          <p>Amazon Shopper Panel</p><br />
          <img src={'img/amazon_shopper_panel.png'} style={{ width: '60%' }} />
          <br />
          <br />
          <br />
          <br />
          <br />
          <p>Japanese Mame</p><br />
          <img src={'img/Japanese_Mame.png'} style={{ width: '60%' }} />
          <br />
          <br />
          <br />
          <br />
          <br />
          <p>Web3 Pet Game</p><br />
          <img src={'img/chicken_demo.png'} style={{ width: '60%' }} />
          <br />
          <img id='onBtnImg' src={`/images/${imgId}.png`} style={{ height: '96px' }} />
          <br />
          <Link to={`/galary`}>
            <Button>
              NFT CHICKEN GALLERY
            </Button>
          </Link>
          <br />
          <br />
          <br />
          <br />
          <br />
          <p>HCI Publication</p><br />
          <img src={'img/eye_protect.png'} style={{ width: '60%' }} />
          <br />
          <br />
          <br />
          <br />
          <br />
          


          <div style={{ background: 'white', width: '100%', padding: '30px 0px 30px 0px' }} className="pure-u-1 pure-u-md-1-3 pure-u-lg-1-4 pure-u-xl-1-5" >
            <h2 style={{ fontFamily: "'Fredericka the Great', cursive", fontWeight: 'normal' }} >Clients</h2><br /><br />
            <img src={'img/BUlogo.png'} style={{ height: '70px', margin: '10px' }} />
            <img src={'img/c1.png'} style={{ height: '70px', margin: '10px' }} />
            <img src={'img/Amazon-logo.png'} style={{ height: '70px', margin: '10px' }} />
            <img src={'img/iLab.png'} style={{ height: '70px', margin: '10px' }} />
            <img src={'img/blade.png'} style={{ height: '70px', margin: '10px' }} />
            <img src={'img/NTUlogo.png'} style={{ height: '70px', margin: '10px' }} />
          <br /><br />
          </div>
          
          <br /><br /><br /><br /><br /><br />

        </div>
        {/*<p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p><p>tst</p>*/}
      </Sky>
      <Footer imgClass={imgClassList[imgClassId]} />

    </div>
  )
}

export default LandingPage;
